import { OnInit, Component, Input, ChangeDetectorRef } from '@angular/core';
import { UserAuditHistoryFilters } from 'src/app/intefaces/user-audit-history-filters.interface';
import { UserAuditHistoryPreparedData } from 'src/app/intefaces/user-audit-history-prepared-data.interface';
import { AdminService } from 'src/app/services/admin.service';
import { AuditHistoryService } from 'src/app/services/auditHistory.service';

@Component({
    selector: 'app-user-audit-history',
    templateUrl: './user-audit-history.component.html',
    styleUrls: ['./user-audit-history.component.scss']
})
export class UserAuditHistoryComponent implements OnInit {

    @Input() userId: number;
    userAuditHistoryPreparedData: UserAuditHistoryPreparedData[];
    dateStart: Date;
    dateEnd: Date;
    filters: UserAuditHistoryFilters[];
    selectedFilters: string[] = [];
    rowsOnPage: number = 10;
    totalRecords: number;
    page: number = 0;
    loading: boolean;
    first: number = 0;
    showFilters: boolean = false;
    showData: boolean = false;

    constructor(private adminService: AdminService, private auditHistoryService: AuditHistoryService, private cdRef: ChangeDetectorRef) { }

    ngOnInit(): void {
        this.filters = this.auditHistoryService.getFilters();
        this.onSelectAllFilters();
        this.loadHistory();
    }

    public onToggleFilters(): void {
        this.showFilters = this.showFilters == true ? false : true;
    }

    public onLoadUserAuditHistoryLazy(event: any): void {
        this.loading = true;
        this.page = event.first / event.rows;
        this.rowsOnPage = event.rows;
        this.loadHistory();
    }

    public onRefreshSearch(): void {
        this.showFilters = false;
        this.onSelectAllFilters();
        this.dateEnd = null;
        this.dateStart = null;
        this.onSearch();
    }

    public onSelectAllFilters(): void {
        this.filters.forEach(element => {
            this.selectedFilters.push(element.code.toString());
        });
    }

    public onDeselectAllFilters(): void {
        this.selectedFilters = [];
    }

    public onSearch(): void {
        this.loading = true;
        this.page = 0;
        this.first = 0;
        this.loadHistory();
    }

    public loadHistory(): void {
        this.adminService.getUserAuditHistory(this.userId, this.dateStart, this.dateEnd, this.selectedFilters, this.page, this.rowsOnPage).subscribe(
            response => {
                if (this.page == 0) {
                    this.totalRecords = response.data.total;
                }
                if (response.data.data.length) {
                    this.auditHistoryService.prepareData(response.data.data).then((prepareddata: UserAuditHistoryPreparedData[]) => {
                        this.userAuditHistoryPreparedData = prepareddata;
                        this.loading = false;
                        this.showData = true;
                        this.cdRef.detectChanges();
                    });
                } else {
                    this.userAuditHistoryPreparedData = [];
                    this.loading = false;
                    this.showData = true;
                    this.cdRef.detectChanges();
                }

            }
        );
    }

}